import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/game-builder', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createGame(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post('/game-builder', payload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateConfig(ctx, { id, payload }) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/game-builder/${id}/config`, payload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    setTopicFormat(ctx, { gameId, rtId, questionFormat }) {
      return axios.post(`/game-builder/${gameId}/round-topic/${rtId}/set-format`, { question_format: questionFormat })
    },
    suggestMusicTopic(ctx, { gameId, rtId }) {
      return axios.get(`/game-builder/${gameId}/round-topic/${rtId}/suggest-music-topic`)
    },
    startMusicTopic(ctx, { gameId, rtId, autotopicId, name }) {
      return axios.post(`/game-builder/${gameId}/round-topic/${rtId}/start-topic`, {
        autotopic_id: autotopicId ?? null,
        name: name ?? null,
      })
    },
    suggestMusicQuestion(ctx, { gameId, rtId, params } = {}) {
      return axios.get(`/game-builder/${gameId}/round-topic/${rtId}/suggest-music-question`, { params })
    },
    acceptMusicQuestion(ctx, { gameId, rtId, payload }) {
      return axios.post(`/game-builder/${gameId}/round-topic/${rtId}/accept-music-question`, payload)
    },
    updateBuilderQuestion(ctx, { gameId, questionId, payload }) {
      return axios.patch(`/game-builder/${gameId}/questions/${questionId}`, payload)
    },
    addQuestionPart(ctx, { gameId, questionId, payload }) {
      return axios.post(`/game-builder/${gameId}/questions/${questionId}/parts`, payload)
    },
    updateQuestionPart(ctx, { gameId, questionId, partId, payload }) {
      return axios.patch(`/game-builder/${gameId}/questions/${questionId}/parts/${partId}`, payload)
    },
    deleteQuestionPart(ctx, { gameId, questionId, partId }) {
      return axios.delete(`/game-builder/${gameId}/questions/${questionId}/parts/${partId}`)
    },
    reorderQuestionParts(ctx, { gameId, questionId, order }) {
      return axios.post(`/game-builder/${gameId}/questions/${questionId}/parts/reorder`, { order })
    },
    replaceQuestionAudioPart(ctx, { gameId, questionId, partId, payload }) {
      return axios.post(`/game-builder/${gameId}/questions/${questionId}/parts/${partId}/replace-audio`, payload)
    },
    searchArtists(ctx, params) {
      return axios.get('/artist', { params })
    },
    fetchArtistTracks(ctx, { artistId }) {
      return axios.get('/track', {
        params: {
          artist_id: artistId,
          has_file: 1,
          sort_by: 'play_count',
          sort_desc: 1,
          per_page: 200,
        },
      })
    },
    loadGame(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/game-builder/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    suggestAutotopic(ctx, { gameId, rtId }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/game-builder/${gameId}/round-topic/${rtId}/suggest-autotopic`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    acceptAutotopic(ctx, { gameId, rtId, autotopicId }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/game-builder/${gameId}/round-topic/${rtId}/accept-autotopic`, { autotopic_id: autotopicId })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    suggestMovie(ctx, { gameId, rtId, params } = {}) {
      return axios.get(`/game-builder/${gameId}/round-topic/${rtId}/suggest-movie`, { params })
    },
    searchCandidates(ctx, { gameId, rtId, params }) {
      return axios.get(`/game-builder/${gameId}/round-topic/${rtId}/candidates`, { params })
    },
    suggestDistractor(ctx, { gameId, rtId, params }) {
      return axios.get(`/game-builder/${gameId}/round-topic/${rtId}/suggest-distractor`, { params })
    },
    acceptQuestion(ctx, { gameId, rtId, payload }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/game-builder/${gameId}/round-topic/${rtId}/accept-question`, payload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteQuestion(ctx, { gameId, rtId, questionId }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/game-builder/${gameId}/round-topic/${rtId}/question/${questionId}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    moveQuestionSlot(ctx, {
      gameId, rtId, questionId, slot,
    }) {
      return axios.patch(`/game-builder/${gameId}/round-topic/${rtId}/question/${questionId}/slot`, { slot })
    },
    removeTopic(ctx, { gameId, rtId }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/game-builder/${gameId}/round-topic/${rtId}/remove-topic`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteGame(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/game-builder/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchAutotopics(ctx, params = {}) {
      return new Promise((resolve, reject) => {
        axios
          .get('/autotopic', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    exportSiq(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/game-builder/${id}/export-siq`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    downloadSiq(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/game-builder/${id}/download-siq`, { responseType: 'blob' })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    finalizeGame(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/game-builder/${id}/finalize`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
